import { api } from '../config/Master';
import axios, { AxiosPromise } from 'axios';

const getSiteAttributes = (pageName): AxiosPromise => {
  return axios({
    method: 'GET',
    url: `${api}/settings/attributes?source=${pageName}`,
  });
};

export { getSiteAttributes };
